import React from 'react'
import { List, Set } from 'immutable'
import { createStopsIndex, stopsPredicate } from './stops'
import numeral from 'numeral'
import { withStateHandlers } from 'recompose'


/** Ui controls for a filter that matches offers based
 * on an all flights in a filter matching at least one
 * of the stop options, unless none are selected,
 * in which case an option always matches.
 */
const StopsFilter = ({ offers = List(), stopSelection, toggleStopOption }) => {
    const stopsIndex = createStopsIndex(offers)

    return shouldShow(stopsIndex)
        ? <div className="filter priceRange">
            <h4>Stops</h4>
            <ul className="priced" id="stops_filter">
                {stopsIndex.map((info, stopCount) =>
                    <li key={stopCount}>
                        <label className="css-checkbox">
                            <input
                                type="checkbox"
                                value={stopCount}
                                onChange={toggleStopOption}
                                checked={stopSelection.includes(stopCount)} />
                            <i />
                            <CountLabel stopCount={stopCount}/>
                            <span className="amount">
                                { numeral(info.get('lowest',0)).format('0,0') }
                            </span>
                        </label>
                    </li>
                ).valueSeq()}
            </ul>
        </div>
        : null
}


const CountLabel = ({stopCount}) => {
    const text = stopCount === 0
        ? 'Non-stop'
        : `${stopCount} stop${stopCount !== 1 ? 's' : ''}`
    return <span className="text">{text}</span>
}


export default withStateHandlers(
    // Initial state
    ({offers}) => ({  // To pre-select all options
        // To pre-select all options
        stopSelection : Set(createStopsIndex(offers).keySeq()) // Contains integers, as stop counts
    }),

    // {
    //     stopSelection : Set() // To pre-select no options
    // },
    // State change handlers
    {
        /** Responds to stops checkbox tick/untick */
        toggleStopOption : ({stopSelection},{onFilter}) => e => {
            const stopCount = parseInt(e.target.value, 10)
            const newStopSelection = e.target.checked
                ? stopSelection.add( stopCount )
                : stopSelection.remove( stopCount )

            // Update filtering
            // This option doesn't filter at all upon no selection
            // onFilter( newStopSelection.isEmpty()
            //     ? null
            //     : stopsPredicate(newStopSelection))
            // This option un-selects all flights upon no selection
            onFilter(stopsPredicate(newStopSelection))

            // New state
            return { stopSelection : newStopSelection }
        }
    }
)(StopsFilter)


/** Should the filter render at all? */
const shouldShow = (stopsIndex = Map()) =>
    // If there is only one stops count, but that count is NOT 0 (non-stop)
    (stopsIndex.size === 1 && stopsIndex.get(0) == null) ||
    // Or there are more than one stop count
    (stopsIndex.size > 1)



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/stops/StopsFilter.js